import * as React from 'react';

import * as styles from './styles.css';
import { EStarRating } from '../../../../packages/JsonQuery';
import { Checkbox } from '../../../common/components/Checkbox';
import { starRatingOptions } from '../../constants/starRatingOptions';
import { Filter } from '../Filter';

interface IStarRatingOptionsProps {
  value: EStarRating[] | null;
  onChange(type: EStarRating, value: boolean): void;
}

export function StarRatingOptions({ value, onChange }: IStarRatingOptionsProps) {
  const content = React.useMemo(
    () =>
      starRatingOptions.map(({ value: starRating, label }) => {
        const isChecked = value?.includes(starRating) || false;
        const onCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) =>
          onChange(starRating, event.target.checked);

        return (
          <Checkbox
            key={starRating}
            className={styles['field']}
            name={label}
            label={label}
            value={String(starRating)}
            checked={isChecked}
            onChange={onCheckboxChange}
          />
        );
      }),
    [value, onChange],
  );

  return (
    <Filter id="filter_star_rating" className={styles['wrapper']}>
      {content}
    </Filter>
  );
}
